import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const MainDiv = styled.div`
  z-index:10000;
  width: ${props => props.collapsed ? '70px' : '250px'};
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #191642;
  box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.1);
  color: #706D9D;
  font-size: 16px;
  font-weight: 600;
  transition: all 0.3s;
  overflow-y: hidden;
  overflow-x: scroll;
  flex-shrink: 0;
`;
export const LogoDiv = styled.div`
  display: flex;
  align-items: center;
  padding: 25px 30px;
  & img:first-child {
    width: 48px;
    height: 36px;
    margin-right: 12px;
  }
  & img:last-child {
    width: 100px;
    height: 24px;
  }
`;
export const MenuDiv = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100vh;
  overflow: scroll;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  
  /* Chrome, Safari, and newer Edge */
  &::-webkit-scrollbar {
    display: none;
  }
`;
export const ColumnOneDiv = styled.div`
  display: flex;
  flex-direction: column;
  transition: all 0.3s;
`;
export const LevelOneDiv = styled.div`
  display: flex;
  align-items: center;
  padding: 18px 38px;
  cursor: pointer;
  white-space: nowrap;
  position: relative;
  color: ${props => props.color};
  & img {
    width: 24px;
    margin-right: 21px;
    flex-shrink: 0;
  }
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
  &:after {
    content: '';
    display: ${props => props.haveSub ? 'block' : 'none'};
    height: 5px;
    width: 5px;
    border-right: 2px solid ${props => props.color};
    border-bottom: 2px solid ${props => props.color};
    transform: ${props => props.isExpand ? 'rotate(-135deg)' : 'rotate(45deg)'};
    position: absolute;
    top: 26px;
    right: 20px;
    transition: all 0.3s;
  }
`;
export const LevelOneLink = styled(Link)`
  display: flex;
  align-items: center;
  padding: 18px 38px;
  cursor: pointer;
  white-space: nowrap;
  position: relative;
  color: ${props => props.color};
  text-decoration: none;
  & img {
    width: 24px;
    margin-right: 21px;
    flex-shrink: 0;
  }
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
    color: ${props => props.color};
  }
  &:after {
    content: '';
    display: ${props => props.haveSub ? 'block' : 'none'};
    height: 5px;
    width: 5px;
    border-right: 2px solid ${props => props.color};
    border-bottom: 2px solid ${props => props.color};
    transform: ${props => props.isExpand ? 'rotate(-135deg)' : 'rotate(45deg)'};
    position: absolute;
    top: 26px;
    right: 20px;
    transition: all 0.3s;
  }
`;
export const ColumnTwoDiv = styled.div`
  height: ${props => props.isExpand ? `${props.sub * 40}px` : '0px'};
  display: flex;
  flex-direction: column;
  transition: all 0.3s;
  border-right: 6px solid #FF2C91;
  background-color: #141138;
  overflow: hidden;
  box-shadow: inset 0px 0 0 black, inset 0 -1px 0 #262256, inset 0px 0 0 black, inset 0 1px 0 black;
`;
export const LevelTwoLink = styled(Link)`
  height: 40px;
  display: flex;
  align-items: center;
  font-size: 14px;
  padding: 0px 38px 0px 82px;
  cursor: pointer;
  white-space: nowrap;
  color: ${props => props.color};
  position: relative;
  flex-shrink: 0;
  text-decoration: none;
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
    color: ${props => props.color};
  }
  &:before {
    content: '';
    height: 9px;
    width: 9px;
    border-radius: 8px;
    position: absolute;
    top: 16px;
    left: 46px;
    z-index: 1;
    background-color: ${props => props.color};
  }
  &:after {
    content: '';
    height: 40px;
    width: 1px;
    position: absolute;
    top: -18px;
    left: 50px;
    background-color: #706D9D;
  }
`;
export const LogoutLink = styled(Link)`
  display: flex;
  z-index:1;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
  padding: 20px 32px;
  cursor: pointer;
  & img {
    height: 20px;
    width: 20px;
    margin-right: 6px;
  }
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
`;
